export default __webpack_public_path__ + "static/media/dv_3.3a434d50.svg";